import type { WeatherSnapshot } from '@grosync/common';
import { apiGet } from './client';

/** 좌표 기준 현재+단기예보(+시간별) 스냅샷. KMA 미설정 시 서버가 503 → 호출측 폴백. */
export function fetchWeather(lat: number, lng: number, name?: string): Promise<WeatherSnapshot> {
  const params = new URLSearchParams({ lat: String(lat), lng: String(lng) });
  if (name) params.set('name', name);
  return apiGet<WeatherSnapshot>(`/api/weather?${params.toString()}`);
}
